import styles from "./index.module.scss";
import MyModal from "../../../../Common/my-modal/my-modal.component";
import cn from "../../../../../Utils/class-names.utils";
import { FormikProps } from "formik";
import { IEmailTemplateFormValues } from "../../../../../common/validations/email-templates.validations";
import { ReactElement } from "react";
import SendEmailIcon from "../../../../icons/send-email.icon";

interface IProps<T extends IEmailTemplateFormValues> {
  title: string;
  formikProps: FormikProps<T>;
  onCancel: () => void;
  onSave: () => void;
  isValid: boolean;
  isSubmitting: boolean;
  formContentComponent: (formikProps: FormikProps<T>) => ReactElement;
}

const ModalOptions = <T extends IEmailTemplateFormValues>({ 
  title, 
  formikProps, 
  onCancel, 
  onSave, 
  isValid, 
  isSubmitting,
  formContentComponent
}: IProps<T>) => {
  return (
    <div className={styles.modalOptions}>
      <div className={styles.header}>
        <p className={styles.title}>
          {title}
        </p>
      </div>
      {formContentComponent(formikProps)}
      <MyModal.Footer className={cn("d-flex justify-content-between border-top", styles.footer)}>
        <button className="my-button styled d-flex align-items-center">
          <div className="left-icon">
            <SendEmailIcon className="f-grey" />
          </div>
          <span className="f-14 line-height-22 f-500 f-grey">
            Send Test
          </span>
        </button>
        <div className="d-flex justify-content-end gap-8">
          <MyModal.CancelButton onClick={onCancel}>
            <span>Cancel</span>
          </MyModal.CancelButton>
          <MyModal.ApplyButton 
            onClick={onSave} 
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
          >
            <span>Save</span>
          </MyModal.ApplyButton>
        </div>
      </MyModal.Footer>
    </div>
  );
};

export default ModalOptions;
